export default __webpack_public_path__ + "static/20-3a63d6229c490a2b4f170f149ab7101c.jpg";